import React from 'react';
import {
  Banner,
  Contact,
  Partner,
  Process,
  Service,
  Techno,
  Blog,
  OurProjectsLogo
} from '../../sections';

const HomePage = () => {
  return (
    <div>
      <Banner />
      <Service />
      <Techno />
      <OurProjectsLogo />
      <Process />
      <Partner />
      <Contact />
      <Blog />
    </div>
  );
};

export default HomePage;
